import { post, put, get, deleteReq } from './api';

export const serializeTagsAsGetParam = tags => {
  if (!tags || !tags.length) return '';
  return tags.map(tag => tag).join('&tags[]=');
};

export const composeQuery = queryObject =>
  Object.keys(queryObject)
    .map(key => (queryObject[key] ? `${key}=${queryObject[key]}` : null))
    .join('&');

export const fetchExtensions = ({ folderId }) =>
  get(`/folders/${folderId}/extensions`);

export const fetchExtensionsList = ({ type, name, tags }) => {
  const queryObject = {
    type,
    name,
    'tags[]': serializeTagsAsGetParam(tags),
  };
  return get(`/extensions?${composeQuery(queryObject)}`);
};

export const fetchExtensionsListByName = ({ query, type }) =>
  get(`/extensions?type=${type}${query ? `&name=${query}` : ''}`);

export const fetchExtensionsRelatedTagsList = ({ tags, type }) =>
  get(
    `/extensions/tags/related?tags[]=${serializeTagsAsGetParam(
      tags
    )}&type=${type}`
  );

export const fetchExtensionsTagsList = ({ query, type }) => {
  const queryObject = {
    q: query,
    type,
  };
  return get(
    `/extensions/tags?${composeQuery(queryObject)}&omitFolderTags=true`
  );
};

export const createNewExtension = extension =>
  post(`/extensions/`, JSON.stringify(extension), {
    'Content-Type': 'application/json',
  });

export const editExtension = ({ extension }) =>
  put(`/extensions/${extension.id}`, JSON.stringify({ extension }), {
    'Content-Type': 'application/json',
  });

export const deleteExtension = ({ id }) =>
  deleteReq(`/extensions/${id}`, {
    'Content-Type': 'application/json',
  });

export const fetchExtension = ({ id }) => get(`/extensions/${id}`);



// WEBPACK FOOTER //
// ./src/services/extensionApi.js